var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{attrs:{"app":""}},[_c('v-container',[_c('v-expand-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('div',{staticClass:"flex-grow-1"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }